import Typography from "@mui/material/Typography";
import { useLocation } from "react-router-dom";

import { strings } from "../../localization/localization";
import StyledContainerHeader from "./StyledContainerHeader";

const ContainerTitle = () => {
  const location = useLocation();
  return (
    <StyledContainerHeader>
      <Typography variant="h5" sx={{ color: "text.primary" }}>
        {strings.getString(location.pathname.substring(1))}
      </Typography>
    </StyledContainerHeader>
  );
};

export default ContainerTitle;
